import React from 'react';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import usePageHandleRedirectOnClose from 'Views/Page/Hooks/usePageHandleRedirectOnClose';
import Content from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content';

export default function FundingInstructionCompleteTemplate({
  resource,
}) {
  const { handleRedirectOnClose } = usePageHandleRedirectOnClose();

  return <>
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
      onNext={handleRedirectOnClose}
      hideBack
    />
  </>;
}
